<template>
  <div class="url-field-embed">
    <div v-if="urlType === 'vimeo'" class="video-wrapper">
      <iframe
        :src="'https://player.vimeo.com/video/' + urlReferenceId"
        frameborder="0"
        allowfullscreen
      ></iframe>
    </div>
    <div v-if="urlType === 'youtube'" class="video-wrapper">
      <iframe
        :src="'https://www.youtube.com/embed/' + urlReferenceId"
        frameborder="0"
        allowfullscreen
      ></iframe>
    </div>
    <div v-if="urlType === 'url'" class="preview-container">
      <redirector :url="url" :external-url="externalUrl">
        <img :src="url2png" class="img-responsive" alt="" />
      </redirector>
    </div>
  </div>
</template>

<script>
import Redirector from '../Shared/Redirector';

export default {
  components: { Redirector },
  props: {
    urlType: {
      type: String,
      required: true,
      validator: prop => ['vimeo', 'youtube', 'url'].indexOf(prop) !== -1
    },
    url: {
      type: String,
      required: true,
      description: 'Full url'
    },
    externalUrl: {
      type: String,
      default: null,
      description: 'Url to AwardForce redirector, used only for an `url` type'
    },
    url2png: {
      type: String,
      default: null,
      description: 'Url to a preview of user input, used only for an `url` type'
    },
    urlReferenceId: {
      type: String,
      default: null,
      description: 'Vimeo video id or YouTube video id'
    }
  }
};
</script>
